import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import data from "./data"; // Your post data
import Header from "./DashProBlogsComponent/Header";
import NewStory from "./DashProBlogsComponent/NewStory/NewStory";
import Bookmark from "./DashProBlogsComponent/Bookmark/Bookmark";
import Content from "./DashProBlogsComponent/Content/Content";
import Post from "./DashProBlogsComponent/Content/Post"; // Import the Post component
import { useUtil } from "../../../contexts/UtilContext";
import { toast } from "react-toastify";
import axios from "axios";
import styles from "./DashProBlogs.module.css";

const DashProBlogs = ({ accessToken }) => {
  const { showLoader, hideLoader } = useUtil();
  const [searchParams, setSearchParams] = useSearchParams();
  const [posts, setPosts] = useState([]);

  // Get the current view and postId from search params
  const view = searchParams.get("view") || "new-story"; // Default to "new-story"
  const postId = searchParams.get("postId"); // Get postId from search params

  const handleBookmark = (data) => {
    setPosts((prevPosts) =>
      prevPosts.map((post) =>
        post === data ? { ...post, bookmark: true } : post
      )
    );
  };

  const handleRemoveBookmark = (bookmark) => {
    setPosts((prevPosts) =>
      prevPosts.map((post) =>
        post.id === bookmark.id ? { ...post, bookmark: false } : post
      )
    );
  };

  const handleSubmission = (data) => {
    setPosts((prevPosts) => [data, ...prevPosts]);
  };

  const handleRemove = (post) => {
    setPosts((prevPosts) =>
      prevPosts.filter((onepost) => onepost.id !== post.id)
    );
    const newSearchParams = new URLSearchParams(searchParams.toString());
    newSearchParams.delete("postId"); // Optional: clear postId if needed
    setSearchParams(newSearchParams);
  };

  const navigateToView = (view) => {
    const newSearchParams = new URLSearchParams(searchParams.toString());
    newSearchParams.set("view", view);
    setSearchParams(newSearchParams);
  };

  // Find the specific post if postId is provided
  const selectedPost = postId
    ? posts.find((post) => post.id === parseInt(postId))
    : null;

  useEffect(() => {
    const fetchProBlogs = async (accessToken) => {
      try {
        showLoader();
        const response = await axios.get(
          `${import.meta.env.VITE_BACKEND_URL}/dash/pro-blog/list`,
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          }
        );

        if (response.status === 200 && response.data && response.data.success) {
          const sortedBlogs = response.data.proBlogs.sort(
            (a, b) => new Date(b.updated_at) - new Date(a.updated_at)
          );

          // console.log("Sorted pro blogs: ", sortedBlogs);
          setPosts(sortedBlogs);
        } else {
          toast.error(response.data.message || "Failed to fetch the licenses.");
        }
      } catch (error) {
        toast.error("Error while fetching the licenses");
        console.error("Error: ", error);
      } finally {
        hideLoader();
      }
    };

    if (accessToken) {
      fetchProBlogs(accessToken);
    }

    return () => {};
  }, [accessToken]);

  return (
    <div className="App">
      <h2 className={styles.pageTitle}>Make a new blog post!</h2>
      <Header />

      {/* Render Components Based on Current View */}
      {view === "new-story" && (
        <NewStory
          handleSubmission={handleSubmission}
          accessToken={accessToken}
        />
      )}
      {view === "content" && (
        <>
          {selectedPost ? (
            <Post
              post={selectedPost}
              handleBookmark={handleBookmark}
              handleRemoveBookmark={handleRemoveBookmark}
              handleRemove={handleRemove} // Ensure handleRemove is passed here
            />
          ) : (
            <Content
              posts={posts}
              handleBookmark={handleBookmark}
              handleRemoveBookmark={handleRemoveBookmark}
              handleRemove={handleRemove} // Pass handleRemove to Content
            />
          )}
        </>
      )}
      {view === "bookmarks" && (
        <Bookmark
          bookmarks={posts.filter((post) => post.bookmark)}
          handleRemoveBookmark={handleRemoveBookmark}
        />
      )}
    </div>
  );
};

export default DashProBlogs;
